// Billing/Shipping address display — 3-line name/street/city-region-zip
// grouping with a copy-all button. Extracted into its own file (rather than
// staying local to App.jsx) so DocumentDetailWindow.jsx can import it too
// without creating a circular App.jsx <-> DocumentDetailWindow.jsx
// dependency (App.jsx itself imports DocumentDetailWindow.jsx).
import { Box, Typography, Stack } from '@mui/material'
import { CopyButton } from './CopyButton.jsx'
import { addressLines } from './addressFormat.js'

// country (optional, 2026-10-07): its own line, only when present.
export function AddressBlock({ heading, name, address1, address2, city, region, postalCode, country = null }) {
  if (!name && !address1 && !address2 && !city && !region && !postalCode && !country) return null
  return (
    <Box sx={{ minWidth: 0 }}>
      <Stack direction="row" spacing={0.25} alignItems="center">
        <Typography variant="caption" color="text.secondary" display="block" sx={{ lineHeight: 1.2, fontWeight: 700 }}>{heading}</Typography>
        {/* Plain-text "copy all": the same lines the block shows, one per line. */}
        <CopyButton value={addressLines({ name, address1, address2, city, region, postalCode, country }).join('\n')} />
      </Stack>
      {name && <Typography variant="body2" sx={{ fontSize: 13, color: 'text.secondary' }}>{name}</Typography>}
      {(address1 || address2) && <Typography variant="body2" sx={{ fontSize: 13, color: 'text.secondary' }}>{[address1, address2].filter(Boolean).join(' ')}</Typography>}
      {(city || region || postalCode) && <Typography variant="body2" sx={{ fontSize: 13, color: 'text.secondary' }}>{[city, region, postalCode].filter(Boolean).join(', ')}</Typography>}
      {country && <Typography variant="body2" data-testid="address-country" sx={{ fontSize: 13, color: 'text.secondary' }}>{country}</Typography>}
    </Box>
  )
}
